import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installClientErrorLog } from './utils/clientErrorLog';

installClientErrorLog();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Option 1: Log to console (useful for development)
reportWebVitals(console.log);

// Option 2: Send to analytics endpoint (uncomment and configure for production)
// reportWebVitals((metric) => {
//   // Example: Send to your analytics service
//   fetch('/api/analytics', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(metric)
//   }).catch(err => console.error('Analytics error:', err));
// });

// Option 3: Custom handler (combine logging and analytics)
// reportWebVitals((metric) => {
//   console.log(metric); // Log for debugging
//   // Send to analytics in production
//   if (process.env.NODE_ENV === 'production') {
//     // Your analytics code here
//   }
// });




